import { useCallback, useEffect } from 'react';
import { createConsumer, getConfig } from '@rails/actioncable';
import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';
import { useDispatch } from 'react-redux';

// Actions
import { catchUpdateAiSocketSuccess } from 'Shared/actions/UpdateAiSettings.actions';

// Hooks
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

const cable = createConsumer(getConfig('url'));

type Props = {
  reportSlug: string;
};

export const useUpdateAiSocket = ({ reportSlug }: Props) => {
  const dispatch = useDispatch();
  const { id: userId } = useCurrentUser();

  const createUpdateAiChannel = useCallback(
    () =>
      cable.subscriptions.create(
        { channel: 'UpdateAiChannel', user_id: userId },
        {
          received: response => {
            dispatch(
              catchUpdateAiSocketSuccess({ reportSlug, body: mapKeys(response, (value, key) => camelCase(key)) })
            );
          },
        }
      ),
    [reportSlug]
  );

  useEffect(() => {
    let updateAiChannel;
    if (reportSlug) {
      updateAiChannel = createUpdateAiChannel();
    }
    return () => {
      if (updateAiChannel) updateAiChannel.unsubscribe();
    };
  }, [createUpdateAiChannel, reportSlug]);
};
